import { type RefObject, useEffect, useRef, useState } from 'react'
type MutationFilter = (mutation: MutationRecord) => boolean
function useMutationObserver<T extends HTMLElement>(
  ref: RefObject<T>,
  filter?: (mutation: MutationRecord) => boolean,
  options?: MutationObserverInit | undefined
) {
  const observerRef = useRef<MutationObserver | null>(null)
  const filterRef = useRef<MutationFilter | null>(null)
  const [observed, setObserved] = useState<MutationRecord | null>(null)

  useEffect(() => {
    filterRef.current = filter ?? null
  }, [filter])

  useEffect(() => {
    observerRef.current = new MutationObserver((muts) => {
      for (const mut of muts) {
        const passes = typeof filterRef.current !== 'function' || filterRef.current(mut)
        if (!passes) continue
        setObserved(mut)
      }
    })
    observerRef.current.observe(ref.current, options)
    return () => {
      observerRef.current?.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return observed
}

export default useMutationObserver
